var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero-bg"},[_c('section',{staticClass:"text-center"},[_c('h2',{staticClass:"pb-5 lead"},[_vm._v("Events")])])])}]

export { render, staticRenderFns }